if (!customElements.get("careers-apply")) {
  class CareersApply extends HTMLElement {
    connectedCallback() {
      this.modal = this.modal || this.querySelector(".m-careers-modal");
      if (!this.modal) return;

      // El pop-up se mueve al body para que ningun contenedor de la pagina afecte su posicion.
      document.body.appendChild(this.modal);

      this.root = this.closest(".m-careers-jobs");
      this.picks = Array.from(this.modal.querySelectorAll(".m-careers-modal__pick"));
      this.profiles = Array.from(this.modal.querySelectorAll(".m-careers-modal__profile"));
      this.titleEl = this.modal.querySelector(".m-careers-modal__title");
      this.tagEl = this.modal.querySelector(".m-careers-modal__tag");
      this.leftCol = this.modal.querySelector(".m-careers-modal__left");
      this.formWrap = this.modal.querySelector(".m-careers-modal__form");
      this.opener = null;

      this.onRootClick = this.onRootClick.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onEditorDeselect = this.onEditorDeselect.bind(this);

      if (this.root) this.root.addEventListener("click", this.onRootClick);
      this.modal.addEventListener("click", this.onModalClick);
      document.addEventListener("keydown", this.onKeydown);
      document.addEventListener("shopify:block:select", this.onBlockSelect);
      document.addEventListener("shopify:block:deselect", this.onEditorDeselect);
      document.addEventListener("shopify:section:deselect", this.onEditorDeselect);
    }

    disconnectedCallback() {
      if (this.root) this.root.removeEventListener("click", this.onRootClick);
      document.removeEventListener("keydown", this.onKeydown);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
      document.removeEventListener("shopify:block:deselect", this.onEditorDeselect);
      document.removeEventListener("shopify:section:deselect", this.onEditorDeselect);
      document.documentElement.classList.remove("m-careers-modal-open");
      if (this.modal) this.modal.remove();
    }

    normalize(text) {
      return (text || "").trim().toLowerCase();
    }

    onRootClick(event) {
      const button = event.target.closest(".m-careers-jobs__apply");
      if (!button) return;
      this.open(button.dataset.jobTitle, button);
    }

    onModalClick(event) {
      if (event.target.closest("[data-modal-close]")) this.close();
    }

    onKeydown(event) {
      if (this.modal.hidden) return;
      if (event.key === "Escape") {
        this.close();
        return;
      }
      if (event.key === "Tab") this.trapFocus(event);
    }

    // Editor del tema: al seleccionar un perfil se abre el pop-up para revisarlo.
    onBlockSelect(event) {
      const pick = event.target.closest && event.target.closest(".m-careers-modal__pick");
      if (!pick || !this.modal.contains(pick)) return;
      this.open(pick.dataset.name, null);
    }

    onEditorDeselect(event) {
      if (!this.modal.hidden && (this.modal.contains(event.target) || this.contains(event.target))) {
        this.close();
      }
    }

    trapFocus(event) {
      const focusable = Array.from(
        this.modal.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea')
      ).filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    open(jobTitle, opener) {
      const wanted = this.normalize(jobTitle);
      const pick = this.picks.find((p) => this.normalize(p.dataset.name) === wanted) || this.picks[0];
      if (pick) this.selectProfile(pick);

      this.opener = opener;
      this.modal.hidden = false;
      document.documentElement.classList.add("m-careers-modal-open");
      const closeButton = this.modal.querySelector(".m-careers-modal__close");
      if (closeButton) closeButton.focus();
    }

    close() {
      this.modal.hidden = true;
      document.documentElement.classList.remove("m-careers-modal-open");
      if (this.opener && document.contains(this.opener)) this.opener.focus();
      this.opener = null;
    }

    selectProfile(pick) {
      this.picks.forEach((p) => p.classList.toggle("is-active", p === pick));
      this.profiles.forEach((profile) => {
        profile.hidden = profile.dataset.profileId !== pick.dataset.profileId;
      });

      this.titleEl.textContent = pick.dataset.name;
      const type = pick.dataset.type || "";
      this.tagEl.textContent = type;
      this.tagEl.hidden = !type;
      this.leftCol.scrollTop = 0;

      this.notifyPuesto(pick.dataset.name);
    }

    // Avisa del puesto elegido y, si el formulario de la app tiene un campo "Puesto", lo rellena.
    notifyPuesto(name) {
      if (this.formWrap) this.formWrap.dataset.puesto = name;
      this.dispatchEvent(new CustomEvent("careers:puesto", { bubbles: true, detail: { puesto: name } }));
      this.fillPuestoField(name);
    }

    fieldText(el) {
      const parts = [el.name, el.id, el.placeholder, el.getAttribute("aria-label")];
      if (el.id) {
        const label = this.formWrap.querySelector('label[for="' + el.id + '"]');
        if (label) parts.push(label.textContent);
      }
      return parts.filter(Boolean).join(" ").toLowerCase();
    }

    fillPuestoField(name) {
      if (!this.formWrap) return;
      const fields = this.formWrap.querySelectorAll("input:not([type=hidden]), select, textarea");
      fields.forEach((el) => {
        if (!this.fieldText(el).includes("puesto")) return;

        if (el.tagName === "SELECT") {
          const wanted = this.normalize(name);
          const option = Array.from(el.options).find((o) => this.normalize(o.textContent) === wanted);
          if (!option) return;
          el.value = option.value;
        } else {
          el.value = name;
        }
        el.dispatchEvent(new Event("input", { bubbles: true }));
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  customElements.define("careers-apply", CareersApply);
}
